export const MASCOT = {
  welcome: "https://static.prod-images.emergentagent.com/jobs/59d0b910-a2b6-4405-956c-f3bd4ae0abe2/images/cbde52be5c0b76d89bff45f665c04448e44dcfe69a9e51f39494f6802ba8656e.jpeg",
  think: "https://static.prod-images.emergentagent.com/jobs/59d0b910-a2b6-4405-956c-f3bd4ae0abe2/images/029d2b2685ff1279af563e5ca0a3020ea925655cc8fcfe4bda941ada7189f5d8.jpeg",
};

// Public app URL used for printable QR codes (points to the deployed app)
export const APP_URL = "https://www.riseyourlife.it";


// Real exercise movement illustrations (matched by keyword in the exercise name)
export const EXERCISE_IMAGES = {
  squat: "https://static.prod-images.emergentagent.com/jobs/59d0b910-a2b6-4405-956c-f3bd4ae0abe2/images/9973d414b07bd648bf2b87b34a1cdf32440341a347f60a6c59d50b051dfef177.jpeg",
  pushup: "https://static.prod-images.emergentagent.com/jobs/59d0b910-a2b6-4405-956c-f3bd4ae0abe2/images/6df89d25e795887b0ee05f754bdd3baeddf891b15c4af1bacdf345b8df4dcc92.jpeg",
  plank: "https://static.prod-images.emergentagent.com/jobs/59d0b910-a2b6-4405-956c-f3bd4ae0abe2/images/907961987c937a882e936db9dec8bef466d1da12367c5892763f0cbc2a0fa736.jpeg",
  lunge: "https://static.prod-images.emergentagent.com/jobs/59d0b910-a2b6-4405-956c-f3bd4ae0abe2/images/4952cf0f0edfe5eba48ba763d57cf85ec09d49bce3dd1ea13d367c09e3c78e1c.jpeg",
  run: "https://static.prod-images.emergentagent.com/jobs/59d0b910-a2b6-4405-956c-f3bd4ae0abe2/images/5d600b660018749fb6385ff39e4129fb9d9db63310348292517905e2bb15c206.jpeg",
  generic: "https://static.prod-images.emergentagent.com/jobs/59d0b910-a2b6-4405-956c-f3bd4ae0abe2/images/7d68fb7947b54d8e2b97a7a0b1d8d1db6c97846c32d74e714402805ffa9b6f1a.jpeg",
  deadlift: "https://static.prod-images.emergentagent.com/jobs/59d0b910-a2b6-4405-956c-f3bd4ae0abe2/images/4814d725bae97322993ab6aee9b4d4e7fecd40dfda66800cee751d70d93b9a25.jpeg",
  row: "https://static.prod-images.emergentagent.com/jobs/59d0b910-a2b6-4405-956c-f3bd4ae0abe2/images/477c01f522e360e56b7e62ed9cfa28d68704563de837d028d391252994dfea0f.jpeg",
  burpee: "https://static.prod-images.emergentagent.com/jobs/59d0b910-a2b6-4405-956c-f3bd4ae0abe2/images/84df98a8462d7232630a838004b07e6bfc2f6a5db746939ed5afc3d3a1071c66.jpeg",
};

export function exerciseImage(name = "") {
  const n = (name || "").toLowerCase();
  if (/(stacco|deadlift)/.test(n)) return EXERCISE_IMAGES.deadlift;
  if (/(rematore|row|rowing)/.test(n)) return EXERCISE_IMAGES.row;
  if (/(burpee)/.test(n)) return EXERCISE_IMAGES.burpee;
  if (/(squat|accosciat)/.test(n)) return EXERCISE_IMAGES.squat;
  if (/(push.?up|piegament|flession)/.test(n)) return EXERCISE_IMAGES.pushup;
  if (/(plank|isometric|core)/.test(n)) return EXERCISE_IMAGES.plank;
  if (/(affond|lunge|passo)/.test(n)) return EXERCISE_IMAGES.lunge;
  if (/(cors|run|jog|cardio|camminat|sprint|salti|jump)/.test(n)) return EXERCISE_IMAGES.run;
  return EXERCISE_IMAGES.generic;
}

// Apple-Watch style ring colors per pillar (from design guidelines)
export const RING_COLORS = {
  nutrition: "#799A82",
  exercise: "#C81D6B",
  sleep: "#3F6E85",
  breathing: "#86A6B8",
  cold: "#3E7CA6",
  relationships: "#E08A3C",
};
